import { forwardRef } from "react";
import { Spinner } from "react-bootstrap";

interface PauseCoverProps {
  text?: string;
  spinner?: boolean;
  variant?: string;
}

/**
 * Loading overlay component with optional spinner and text.
 *
 * @param props - The component props
 * @param props.text - Optional text to display alongside the spinner
 * @param props.spinner - Optional. When true, displays a loading spinner
 * @param props.variant - Optional Bootstrap variant for spinner and text color
 */
export const PauseCover = forwardRef<HTMLDivElement, PauseCoverProps>(
  ({ text, spinner = true, variant }: PauseCoverProps, coverRef) => {
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: 1,
          backgroundColor: "#ccc",
          opacity: "0.75",
          color: "--var(--bs-black)",
          borderRadius: "4px",
          border: "1px --var(--bs-dark) solid",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxHeight: "100%",
          cursor: "wait",
        }}
        onClickCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {spinner && (
          <Spinner
            animation="border"
            aria-label="Please wait"
            size="sm"
            variant={variant ?? "dark"}
            style={{ alignSelf: "center" }}
          />
        )}
        {text && (
          <div ref={coverRef}>
            <small className={`text-${variant ?? "dark"} ms-2`}>{text}</small>
          </div>
        )}
      </div>
    );
  },
);

PauseCover.displayName = "PauseCover";
